import type { NextPage } from "next";
import Head from "next/head";

import Landing from "@components/V2/Landing";

const Header = () => (
  <Head>
    <title>
      Kelp – The Leading Liquid Restaking Protocol | Restake Ethereum & Stay
      Liquid
    </title>
    <meta
      name="description"
      content="Kelp is a top liquid restaking protocol with $2B+ TVL. Restake Ethereum (ETH) and other assets while maintaining liquidity with rsETH, live on 40+ DeFi platforms. Maximize your DeFi restaking rewards today."
    />
    <meta
      name="keywords"
      content="KernelDAO, Kelp, Liquid restaking, DeFi restaking, rsETH, DeFi, ETH, Ethereum, Restaking, Rewards, Airdrops, Restaking protocol"
    />
    <meta
      property="og:title"
      content="Kelp – The Leading Liquid Restaking Protocol | Restake Ethereum & Stay Liquid"
    />
    <meta
      property="og:description"
      content="Kelp is a top liquid restaking protocol with $2B+ TVL. Restake Ethereum (ETH) and other assets while maintaining liquidity with rsETH, live on 40+ DeFi platforms. Maximize your DeFi restaking rewards today."
    />
    <link rel="canonical" href="https://kerneldao.com/kelp/" />
    <link rel="icon" href="/favicon.ico" type="image/x-icon" sizes="96x96" />
    <meta name="robots" content="index, follow" />
    <style>
      {`
            html, body {
              background-color: #F4F4F7 !important;
            }
            .chakra-body {
              background-color: #F4F4F7 !important;
            }
          `}
    </style>
  </Head>
);

const Home: NextPage = () => {
  return (
    <>
      <Header />
      <Landing />
    </>
  );
};

export default Home;
